import React from "react";
import Library from "./Library";

const Icon = (props) => <Library name="fa-solid fa-spinner" {...props} />;

Icon.displayName = "Icon.Spinner";
export default Icon;
